<template>
  <div v-if="hasRedeemableVoucher" class="w-full flex-1-0-auto header-height-top-space">
    <div class="w-full pb-4 xl:pb-6">
      <div class="mb-4 md:px-6 lg:px-8 xl:px-20 xl:mb-8">
        <div class="container">
          <StepNavigation
            :step1="tr('pages.sales.steps.step1')"
            :step2="tr('pages.sales.steps.step2')"
            :step3="tr('pages.sales.steps.step3')"
            :active-step="3"
          />
        </div>
      </div>

      <div id="main-content" class="w-full viewport-gutter pt-4 xl:pt-8">
        <div class="container">
          <div class="space-y-3 text-sm xl:text-lg xl:space-y-6">
            <h1 class="text-3xl font-bold leading-none xl:leading-13 xl:text-4xl font-lufthansa-head text-4y-sky-blue">
              {{ tr('pages.sales.confirmation.title') }}
            </h1>
            <p class="leading-7.5 text-2xl font-light max-w-195">
              {{ tr('pages.sales.confirmation.description') }}
              {{ tr('pages.sales.confirmation.descriptionLineTwo') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full pt-6 pb-4 viewport-gutter xl:pt-16 xl:pb-24">
      <div class="container">
        <div class="flex flex-col items-center justify-between w-full xl:items-start xl:max-w-5xl xl:flex-row xl:mx-auto xl:space-x-20">
          <div class="w-full max-w-lg mb-20 xl:mb-0">
            <div class="space-y-8">
              <div class="w-full rounded-xl shadow xl:w-full">
                <div class="flex items-center justify-start px-5 py-4 bg-white rounded-t-xl">
                  <div class="flex-shrink-0 w-24">
                    <svg width="112" height="40" viewBox="0 0 112 40" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-24'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1853_159)"><mask id="a" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="112" height="40"><path d="M112 .65H0v38.7h112V.65z" fill="#fff"/></mask><g mask="url(#a)"><path d="M5.271 34.203l-1.92.293c-1.146.165-1.81.79-1.81 1.707 0 1.06.601 1.707 1.937 1.707 1.525 0 2.852-.877 2.852-2.624v-1.333c-.345.115-.7.198-1.059.25zm-1.105-5.357c2.608 0 3.73 1.122 3.73 3.066v7.193H6.417v-1.352a3.828 3.828 0 01-3.272 1.525C.933 39.278 0 37.983 0 36.324c0-1.66.98-2.75 2.98-3.067l2.291-.371c.812-.105 1.082-.42 1.082-1.107 0-.92-.584-1.565-2.212-1.565-1.413 0-1.96.482-2.087 1.375H.491c.143-1.541 1.233-2.727 3.667-2.727l.008-.016zM12.25 29.1h-1.566v10.005h1.565V29.1zM16.896 29.1V30.4c.433-.854 1.273-1.542 2.838-1.542.14-.003.28.005.418.024v1.542a5.393 5.393 0 00-.774-.04 2.288 2.288 0 00-2.396 2.418v6.314h-1.564V29.108h1.478V29.1zM24.056 24.517h-1.565v14.588h1.565V24.517zM28.624 29.1H27.06v10.005h1.564V29.1zM31.88 29.1h1.478v1.122c.433-.775 1.273-1.374 2.9-1.374 2.213 0 3.626 1.106 3.626 3.895v6.354h-1.578v-6.149c0-2.002-.92-2.647-2.418-2.647-1.499 0-2.443.65-2.443 2.647v6.15h-1.564V29.1zM49.211 33.227c-.142-2.125-1.02-3.018-2.75-3.018s-2.607 1.058-2.79 3.018h5.54zm1.564 1.31h-7.153c.105 2.19 1.004 3.438 2.853 3.438 1.295 0 2.041-.395 2.48-1.478h1.629c-.482 1.897-1.896 2.853-4.109 2.853-3.003 0-4.418-2.002-4.418-5.256 0-3.254 1.399-5.255 4.396-5.255 2.998 0 4.34 1.832 4.34 5.042a6.31 6.31 0 01-.024.65l.006.006zM60.125 31.582h-1.58c-.206-.98-.83-1.376-2.041-1.376-1.288 0-1.96.546-1.96 1.479 0 .727.372 1.248 1.413 1.413l1.414.23c2.04.33 2.956 1.232 2.956 2.915 0 2.102-1.526 3.106-3.936 3.106-2.648 0-3.691-1.106-3.936-2.853h1.579c.166.957.775 1.502 2.355 1.502 1.707 0 2.332-.711 2.332-1.628 0-.854-.42-1.375-1.644-1.565l-1.413-.253c-1.81-.292-2.727-1.233-2.727-2.774 0-1.755 1.233-2.94 3.564-2.94 2.149 0 3.398.942 3.625 2.727v.017zM12.368 26.231a.9.9 0 11-1.802 0 .9.9 0 011.802 0zM28.735 26.231a.9.9 0 11-1.8 0 .9.9 0 011.8 0zM7.69 17.143c-2.356 0-3.35-1.391-3.35-3.777s.994-3.779 3.35-3.779c2.355 0 3.348 1.392 3.348 3.778 0 2.385-.995 3.777-3.35 3.777M10.93.65v6.613a5.764 5.764 0 00-4.173-1.479C1.81 5.784.017 8.74 0 13.308v.13c.016 4.568 1.81 7.516 6.757 7.516 2.07 0 3.493-.68 4.433-1.763v1.336h4.03V.65h-4.29zM102.721 7.865h-.031V6.22h-4.03v14.31h4.283v-8.062c0-1.85 1.136-2.617 2.669-2.617.608 0 1.215.035 1.818.108V5.85a6.93 6.93 0 00-.798-.055c-2.158 0-3.35.964-3.92 2.07h.009zM87.105 11.58c.285-1.707 1.107-2.473 2.956-2.473 2.103 0 2.727.995 2.893 2.473h-5.849zm10.219 1.762c0-4.545-2.07-7.556-7.271-7.556-5.54 0-7.27 3.747-7.27 7.58 0 4.544 2.102 7.578 7.492 7.578 4.26 0 6.503-2.047 6.757-4.829h-4.23c-.253.942-.909 1.392-2.528 1.392-2.134 0-3.036-.822-3.24-2.98H97.25c.044-.396.063-.794.054-1.193l.019.008zM60.284 17.15c-2.356 0-3.35-1.39-3.35-3.777 0-2.386.994-3.778 3.35-3.778 2.355 0 3.35 1.392 3.35 3.778 0 2.387-.995 3.775-3.35 3.775v.002zm0-11.356c-5.453 0-7.69 3.01-7.69 7.578 0 4.568 2.244 7.58 7.686 7.58 5.443 0 7.699-3.012 7.699-7.58 0-4.566-2.243-7.578-7.699-7.578h.004zM37.041 13.373c0 4.228 2.103 7.578 7.492 7.578 4.568 0 6.647-2.102 7.074-5.595h-4.284c-.285 1.193-1.106 1.786-2.782 1.786-1.96 0-3.153-1.304-3.153-3.777 0-2.474 1.193-3.778 3.154-3.778 1.677 0 2.496.601 2.781 1.786h4.284c-.427-3.492-2.498-5.595-7.074-5.595-5.397 0-7.492 3.35-7.492 7.58v.015zM23.242 10.536c0 2.837 1.818 4.063 4.972 4.49l1.502.198c1.477.198 2.046.538 2.046 1.28 0 .798-.68 1.194-2.355 1.194-1.675 0-2.386-.515-2.497-1.565h-4.228C22.769 19 24.5 20.96 29.407 20.96c4.653 0 6.647-1.785 6.647-4.797 0-3.012-1.817-4.117-5.453-4.599l-1.501-.197c-1.217-.175-1.565-.514-1.565-1.137 0-.622.538-1.106 1.96-1.106s1.904.513 2.047 1.335h4.172c-.197-3.098-2.27-4.649-6.22-4.653-4.457 0-6.242 1.984-6.242 4.742l-.01-.013zM78.703 6.222l-3.318 9.759-3.319-9.76h-4.63l5.367 14.305h5.169l5.365-14.304h-4.634zM21.377 6.221h-4.283v14.312h4.283V6.221z" fill="#1F73B0"/><path d="M106.8 18.494a2.599 2.599 0 002.599 2.594 2.597 2.597 0 10-2.599-2.6v.006z" fill="#FC0"/></g></g><defs><clipPath id="clip0_1853_159"><path fill="#fff" transform="translate(0 .65)" d="M0 0h112v38.701H0z"/></clipPath></defs></svg>
                  </div>
                  <div class="font-bold pl-4 ml-4 border-l border-4y-gray-400">
                    {{ tr('pages.sales.confirmation.card.title') }}
                  </div>
                </div>
                <div>
                  <img
                    srcset="~images/discover/confirmation/confirmation-image.png 1x, ~images/discover/confirmation/confirmation-image@2x.png 2x"
                    src="~images/discover/confirmation/confirmation-image.png"
                    class="w-full rounded-b-xl"
                    alt=""
                    role="presentation"
                  >
                </div>
              </div>

              <div class="md:flex ticket">
                <div class="relative flex flex-col flex-1 p-6 pb-4 overflow-hidden bg-4y-sky-blue md:p-4 md:pt-6 md:pb-7 rounded-xl text-white">
                  <div class="flex-1">
                    <div class="w-45 h-6">
                      <img src="~images/discover/logos/logo-white-1line.svg" alt="Discover Airlines Logo">
                    </div>
                    <p class="h-16 text-2xl font-bold md:text-3xl font-lufthansa-head">
                      {{ tr('pages.sales.confirmation.card.title') }}
                    </p>
                  </div>

                  <p class="text-xs">
                    {{ tr('pages.sales.confirmation.details.value') }}
                  </p>
                  <p class="pb-4 text-2xl font-bold">
                    {{ redeemableVoucher.amount | formatCurrency(redeemableVoucher.currency) }}
                  </p>

                  <p class="max-w-48 text-xxs">
                    {{ tr('pages.sales.confirmation.details.validUntilPhrase', { date:
                      $d(new Date(redeemableVoucher.validUntil), 'short', dateFormattingLocale)
                    }) }}
                  </p>

                  <div class="absolute bottom-0 right-0 w-full mr-2 -mb-6 max-w-32">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><switch><g><path d="M12.901 3.566l8.547 10.666 7.885.001h.011A1.772 1.772 0 0 1 31.1 16a1.77 1.77 0 0 1-1.75 1.768h-7.902l-8.547 10.666H9.573l6.272-10.668H7.63L4.96 20.434H1.662L4.557 16l-2.895-4.433H4.96l2.67 2.668h8.215L9.573 3.565h3.328m.432-.9H8l6.272 10.67h-6.27l-2.669-2.668H0L3.482 16 0 21.334h5.333l2.67-2.668h6.27L8 29.334h5.333l8.547-10.666h7.47a2.668 2.668 0 0 0 0-5.335h-7.47L13.333 2.666z" fill="currentColor" /></g></switch></svg>
                  </div>
                </div>
                <div class="ticket__middle" />
                <div class="flex flex-col p-6 pb-4 bg-4y-sky-blue text-white md:p-4 md:flex md:flex-col md:w-40 rounded-xl">
                  <div class="md:mt-4">
                    <p class="pb-px leading-none text-xxs">
                      {{ tr('pages.sales.confirmation.details.code') }}
                    </p>
                    <p class="text-base font-bold uppercase" data-testid="voucher-code">
                      {{ redeemableVoucher.code }}
                    </p>
                  </div>

                  <div class="text-center text-xxs mt-auto">
                    <router-link :to="$i18nTo({ name: 'termsOfUse' })" class="underline hover:no-underline" target="_blank">
                      {{ tr('pages.sales.confirmation.details.terms') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-col items-center w-full max-w-lg mb-10 space-y-6 xl:w-1/2 xl:mb-0 xl:mt-7 xl:block md:space-y-12">
            <div>
              <ul class="space-y-4 md:space-y-8 list-checkmark-2 text-4y-black">
                <li class="flex flex-row space-x-3">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'w-5 h-5 text-4y-teal-green flex-shrink-0'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M19.525 7.295l-8.712 11.3-6.64-5.345 1.881-2.337 4.254 3.424 6.842-8.874z"/></svg>
                  <span v-html="tr('pages.sales.buy.cards.point1')" />
                </li>
                <li class="flex flex-row space-x-3">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'w-5 h-5 text-4y-teal-green flex-shrink-0'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M19.525 7.295l-8.712 11.3-6.64-5.345 1.881-2.337 4.254 3.424 6.842-8.874z"/></svg>
                  <span v-html="tr('pages.sales.buy.cards.point3')" />
                </li>
                <li class="flex flex-row space-x-3">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'w-5 h-5 text-4y-teal-green flex-shrink-0'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M19.525 7.295l-8.712 11.3-6.64-5.345 1.881-2.337 4.254 3.424 6.842-8.874z"/></svg>
                  <span v-html="tr('pages.sales.buy.cards.point4')" />
                </li>
              </ul>
            </div>

            <div class="relative md:w-full md:max-w-68">
              <Button
                variant="primary"
                :loading="downloadingPdf"
                full-width
                @click.prevent="downloadPdf()"
              >
                {{ tr('pages.sales.confirmation.button.download') }}
              </Button>
            </div>
          </div>
        </div>

        <div class="flex justify-center mt-10 xl:mt-24">
          <Button :href="$i18nTo({ name: 'voucherSaleLanding'})" variant="secondary">
            {{ tr('pages.sales.confirmation.button.return') }}
          </Button>
        </div>
      </div>
    </div>

    <SellerNote />
  </div>
</template>

<script>
import SellerNote from '~brand-pages/discover/seller-note.vue'
import StepNavigation from '~brand-components/discover/navigation/step-navigation.vue'
import Button from '~brand-components/discover/button/button.vue'
import VoucherSaleConfirmation from '~brand-pages/base/voucher-sale-confirmation'

export default VoucherSaleConfirmation.extend({
  components: {
    SellerNote,
    StepNavigation,
    Button,
  },
  computed: {
    dateFormattingLocale() {
      if (this.$i18n.locale === 'en') {
        return 'fr'
      }

      return this.$i18n.locale
    },
  },
})
</script>

<style lang="scss" scoped>
.ticket {
  &__middle {
    position: relative;

    &:before {
      content: "";
      height: 9px;
      margin: -2px 0 0 0;
      background-image: url("data:image/svg+xml,%3Csvg width='8' height='4' viewBox='0 0 8 4' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='2' r='2' fill='white'/%3E%3C/svg%3E%0A");

      @apply block absolute left-0 top-0 w-full z-10 bg-repeat-x;
    }
  }
}

@screen md {
.ticket {
  &__middle {
    &:before {
      margin: 8px 0 0 -4px;
      width: 9px;
      height: calc(100% - 17px);
      background-image: url("data:image/svg+xml,%3Csvg width='9' height='205' viewBox='0 0 9 205' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cellipse cx='4.71407' cy='4.35714' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='15.9286' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='27.5' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='39.0714' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='50.6428' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='62.2143' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='73.7857' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='85.3571' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='96.9286' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='108.5' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='120.071' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='131.643' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='143.214' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='154.786' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='166.357' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='177.929' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='189.5' rx='3.85714' ry='3.85714' fill='white'/%3E%3Cellipse cx='4.71407' cy='201.071' rx='3.85714' ry='3.85714' fill='white'/%3E%3C/svg%3E%0A");

      @apply bg-repeat-y;
    }
  }
}
}
</style>
